/* eslint-disable complexity */
import classes from './ToggleButton.module.scss'
import type { ReactNode } from 'react'

interface iconLabelText {
  onLabel: string
  offLabel: string
}
export interface Props {
  ariaLabel?: string
  iconOff?: ReactNode
  isOn: boolean
  iconOn?: ReactNode
  isDisabled?: boolean
  isToggleLeft?: boolean
  label: string
  type?: 'button' | 'submit'
  onChange: (value: boolean) => void
  iconLabelText?: iconLabelText
}

const ToggleButton = ({
  isOn,
  iconOff,
  iconOn,
  isToggleLeft = true,
  isDisabled = false,
  label,
  type = 'button',
  ariaLabel = 'Toggle Button',
  onChange,
  iconLabelText
}: Props) => {
  const handleChange = () => {
    onChange(!isOn)
  }

  const isOnClassName = isOn
    ? classes.isOn
    : ''

  const withIconLabelTextClassName = iconLabelText
    ? classes.withIconLabelText
    : ''

  const isToggleLeftClassName = !isToggleLeft
    ? classes.toggleButtonRightPosition
    : ''

  const getClasses = () => [
    classes.ToggleButton,
    isOnClassName,
    withIconLabelTextClassName,
    isToggleLeftClassName
  ].filter(classStyle => classStyle).join(' ')

  return (
    <div className={getClasses()}>
      <button
        aria-label={ariaLabel}
        disabled={isDisabled}
        onClick={handleChange}
        // eslint-disable-next-line react/button-has-type
        type={type}
      >
        {
          iconLabelText && isOn && <p> {iconLabelText.onLabel} </p>
        }
        <span className={classes.iconColor}>
          {
            isOn
              ? iconOn
              : iconOff
          }
        </span>
        {
          iconLabelText && !isOn && <p> {iconLabelText.offLabel} </p>
        }
      </button>
      {label}
    </div>
  )
}

export default ToggleButton
